import { createSelector } from 'reselect';

const selectdbaassubscriptions = (state: any) => state.dbaassubscriptions;


export const selectdbaassubscriptionsCurrentItem = createSelector([selectdbaassubscriptions], (dbaassubscriptions) => dbaassubscriptions.current);

export const selectdbaassubscriptionsListItems = createSelector([selectdbaassubscriptions], (dbaassubscriptions) => dbaassubscriptions.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectdbaassubscriptionsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectdbaassubscriptionsQueryItems = createSelector([selectdbaassubscriptions], (dbaassubscriptions) => dbaassubscriptions.query);

export const selectdbaassubscriptionsCreatedItem = createSelector([selectdbaassubscriptions], (dbaassubscriptions) => dbaassubscriptions.create);

export const selectdbaassubscriptionsUpdatedItem = createSelector([selectdbaassubscriptions], (dbaassubscriptions) => dbaassubscriptions.update);

export const selectdbaassubscriptionsReadItem = createSelector([selectdbaassubscriptions], (dbaassubscriptions) => dbaassubscriptions.read);

export const selectdbaassubscriptionsDeletedItem = createSelector([selectdbaassubscriptions], (dbaassubscriptions) => dbaassubscriptions.delete);

export const selectdbaassubscriptionsSearchedItems = createSelector([selectdbaassubscriptions], (dbaassubscriptions) => dbaassubscriptions.search);

export const selectdbaassubscriptionsItemsCount = createSelector([selectdbaassubscriptions], (dbaassubscriptions) => dbaassubscriptions.count);

export const selectdbaassubscriptionsItemsFilter = createSelector([selectdbaassubscriptions], (dbaassubscriptions) => dbaassubscriptions.filter);